/**
 * @generated SignedSource<<a857a13752ae544199ad71bc49b7b529>>
 * @relayHash af5cfa2f226e4e47c2c7e5e8515bf11e
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID af5cfa2f226e4e47c2c7e5e8515bf11e

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AccountVerificationStatus = "IN_PROGRESS" | "REJECTED" | "VERIFIED";
export type BetterDoc = "ALLOWED" | "CONDITION_PACKAGE" | "NOT_ALLOWED" | "REQUIRED";
export type CareProviderGroupType = "CHIROPRACTOR" | "DENTIST" | "DOCTOR" | "HOSPITAL" | "NONE" | "NUTRITIONIST" | "PHARMACY" | "PHYSIOTHERAPIST" | "PSYCHOTHERAPIST";
export type ContactChannel = "APP" | "EMAIL_AND_SMS" | "NO_CHANNEL";
export type DayOfWeek = "FRIDAY" | "MONDAY" | "SATURDAY" | "SUNDAY" | "THURSDAY" | "TUESDAY" | "WEDNESDAY";
export type DoctorNetworkRole = "FAMILY_DOCTOR" | "GATEKEEPER" | "SPECIALIST";
export type Gatekeeper = "GENERAL_PRACTITIONER" | "MEDGATE_AND_OTHERS" | "MEDGATE_ONLY" | "NOT_MEDGATE" | "NO_GATEKEEPER";
export type HealthInformationType = "ALLERGY" | "BODY_MEASUREMENT" | "CONDITION" | "FAMILY_HISTORY" | "GYNAECOLOGY" | "SOCIAL_HISTORY";
export type PreventionProgramDismissReason = "APPOINTMENT_ALREADY_BOOKED_THROUGH_MEDGATE" | "PATIENT_HAS_NO_INCREASED_RISK" | "PATIENT_IS_ALREADY_IN_PROGRAM" | "PATIENT_IS_NOT_INTERESTED" | "PATIENT_SELF_ORGANIZES";
export type PreventionProgramEngagementStatus = "BOOKED" | "DISMISSED";
export type ReferralToGeneralPractitioner = "INSURANCE_LIST" | "MPN" | "NONE";
export type ReferralToSpecialist = "INSURANCE_LIST" | "MPN" | "NONE";
export type WorkingType = "CLOSED" | "HOURLY" | "OPEN24_HOURS";
export type chPatientByIdQuery$variables = {
  appointmentId?: string | null;
  language: string;
  patientId: string;
};
export type chPatientByIdQuery$data = {
  readonly patientById: {
    readonly __typename: "ch_Patient";
    readonly account: {
      readonly accountVerification: {
        readonly emailAddress: string;
        readonly phoneNumber: string;
        readonly status: AccountVerificationStatus;
      } | null;
      readonly childProfiles: ReadonlyArray<{
        readonly patient: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"PatientFragment">;
        };
      }>;
      readonly mainProfile: {
        readonly patient: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"PatientFragment">;
        };
      } | null;
    } | null;
    readonly address: {
      readonly city: string;
      readonly country: {
        readonly code: string;
        readonly countryLookupTranslations: ReadonlyArray<{
          readonly countryIsoCode2: string;
          readonly countryName: string;
          readonly language: string;
        }>;
        readonly id: string;
      } | null;
      readonly countryCode: string;
      readonly houseNumberStreet: string;
      readonly postalCode: string;
    } | null;
    readonly allergiesInformation: {
      readonly " $fragmentSpreads": FragmentRefs<"PatientAllergiesOutputFragment">;
    };
    readonly bodyMeasurements: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"PatientBodyMeasurementsOutputFragment" | "PatientBodyMeasurementsOutputFragmentInline">;
      }> | null;
    } | null;
    readonly callerPhoneNumbers: ReadonlyArray<string> | null;
    readonly caveEntry: {
      readonly message: string | null;
      readonly updatedAt: string;
      readonly updatedBy: string;
    } | null;
    readonly ch_hasNonMedgateInDoctorNetwork: boolean;
    readonly conditionInformation: {
      readonly " $fragmentSpreads": FragmentRefs<"PatientConditionInformationOutputFragment">;
    };
    readonly contactChannel: ContactChannel;
    readonly contactChannelUpdatedAt: string | null;
    readonly contextAppointment: {
      readonly " $fragmentSpreads": FragmentRefs<"PatientContextAppointmentFragment">;
    } | null;
    readonly createdAt: string;
    readonly doctorNetworks: ReadonlyArray<{
      readonly careProvider: {
        readonly additionalAddress: string | null;
        readonly billsVia: {
          readonly businessName: string | null;
          readonly firstName: string | null;
          readonly lastName: string | null;
          readonly title: string | null;
        } | null;
        readonly businessName: string | null;
        readonly careProviderGroup: {
          readonly groupType: CareProviderGroupType;
        };
        readonly careProviderSpecialtyTranslations: ReadonlyArray<{
          readonly name: string;
        }>;
        readonly city: string | null;
        readonly country: {
          readonly countryName: string | null;
        } | null;
        readonly countryCode: string | null;
        readonly creditorCodeRegister: string | null;
        readonly detailedSchedule: ReadonlyArray<{
          readonly day: DayOfWeek;
          readonly periods: ReadonlyArray<{
            readonly end: string;
            readonly start: string;
          }> | null;
          readonly workingType: WorkingType;
        }> | null;
        readonly email: string | null;
        readonly firstName: string | null;
        readonly globalLocationNumber: number | null;
        readonly groupName: string | null;
        readonly id: string;
        readonly isMedgatePartnerNetworkMember: boolean | null;
        readonly isTakesNewPatients: boolean | null;
        readonly lastName: string | null;
        readonly network: {
          readonly name: string;
        } | null;
        readonly officialLanguageLookupTranslations: ReadonlyArray<{
          readonly isoLanguageName: string;
        }>;
        readonly officialLanguages: ReadonlyArray<{
          readonly isoLanguageCode: string;
        }>;
        readonly phoneNumber: string | null;
        readonly postalCode: string | null;
        readonly relationBusinessName: string | null;
        readonly relationFirstName: string | null;
        readonly relationLastName: string | null;
        readonly relationTitle: string | null;
        readonly relationType: string | null;
        readonly streetAddress: string | null;
        readonly title: string | null;
        readonly website: string | null;
      };
      readonly id: string;
      readonly role: DoctorNetworkRole;
    }>;
    readonly duplicateOfPatient: {
      readonly id: string;
    } | null;
    readonly emailAddress: string | null;
    readonly emailVerification: {
      readonly createdAt: string;
      readonly sentAt: string | null;
      readonly verifiedAt: string | null;
    } | null;
    readonly familyHistory: {
      readonly " $fragmentSpreads": FragmentRefs<"FamilyHistoryFragment">;
    };
    readonly gynaecology: {
      readonly " $fragmentSpreads": FragmentRefs<"GynaecologyFragment">;
    };
    readonly hasUpcomingPlannedAppointment: boolean;
    readonly healthInformationLastVerification: ReadonlyArray<{
      readonly healthInformationType: HealthInformationType;
      readonly id: string;
      readonly patientId: string;
      readonly verifiedAt: string | null;
      readonly verifiedBy: string | null;
    }>;
    readonly healthInformationVerifications: ReadonlyArray<{
      readonly appointmentId: number;
      readonly healthInformationType: HealthInformationType;
      readonly id: string;
      readonly patientId: string;
      readonly verifiedAt: string | null;
      readonly verifiedBy: string | null;
    }>;
    readonly id: string;
    readonly insurees: ReadonlyArray<{
      readonly activeCoverages: ReadonlyArray<{
        readonly id: string;
        readonly product: {
          readonly id: string;
          readonly isPrimary: boolean;
          readonly name: string;
          readonly organisation: {
            readonly id: string;
            readonly key: string;
          };
          readonly productConfiguration: {
            readonly __typename: "ch_ProductConfiguration";
            readonly betterDoc: BetterDoc;
            readonly betterDocKey: string;
            readonly gatekeeper: Gatekeeper | null;
            readonly isMedgateTeleGeneralPractitioner: boolean | null;
            readonly referralToGeneralPractitioner: ReferralToGeneralPractitioner;
            readonly referralToSpecialist: ReferralToSpecialist;
            readonly shouldContainInsuranceCardNumber: boolean | null;
          } | null;
        };
        readonly updatedAt: string | null;
        readonly validFrom: any;
        readonly validTo: any;
      }>;
      readonly coverages: ReadonlyArray<{
        readonly id: string;
        readonly product: {
          readonly id: string;
          readonly isPrimary: boolean;
          readonly name: string;
          readonly organisation: {
            readonly id: string;
            readonly key: string;
          };
          readonly productConfiguration: {
            readonly __typename: "ch_ProductConfiguration";
            readonly betterDoc: BetterDoc;
            readonly betterDocKey: string;
            readonly gatekeeper: Gatekeeper | null;
            readonly isMedgateTeleGeneralPractitioner: boolean | null;
            readonly referralToGeneralPractitioner: ReferralToGeneralPractitioner;
            readonly referralToSpecialist: ReferralToSpecialist;
            readonly shouldContainInsuranceCardNumber: boolean | null;
          } | null;
        };
        readonly updatedAt: string | null;
        readonly validFrom: any;
        readonly validTo: any;
      }>;
      readonly healthInsuranceCardNumber: string | null;
      readonly id: string;
      readonly insureeNumber: string | null;
      readonly organisation: {
        readonly id: string;
        readonly name: string;
      };
    }>;
    readonly medgateServiceInfo: {
      readonly betterDoc: BetterDoc;
      readonly externalAssistanceServiceInfo: {
        readonly name: string;
      } | null;
      readonly genericsObligation: boolean;
      readonly hasBetterDocConditionPackage: boolean;
      readonly hasInsuranceListReferralToGeneralPractitioner: boolean;
      readonly hasInsuranceListReferralToSpecialist: boolean;
      readonly isEligibleToPartnerPortal: boolean;
      readonly isMedgateTeleGeneralPractitioner: boolean;
      readonly isMedicalChatEnabled: boolean;
      readonly referralToGeneralPractitioner: ReferralToGeneralPractitioner;
      readonly referralToSpecialist: ReferralToSpecialist;
    };
    readonly medications: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly endDate: any | null;
          readonly id: string;
          readonly startDate: any | null;
          readonly " $fragmentSpreads": FragmentRefs<"chMedicationFragment" | "chMedicationFragmentInline">;
        };
      }> | null;
    } | null;
    readonly patientId: string;
    readonly phoneNumber: string | null;
    readonly preventionPrograms: {
      readonly edges: ReadonlyArray<{
        readonly cursor: string;
        readonly node: {
          readonly dismissReason: PreventionProgramDismissReason | null;
          readonly id: string;
          readonly key: string;
          readonly lastUpdated: string | null;
          readonly localizedInstruction: {
            readonly de: string;
            readonly en: string;
            readonly fr: string;
            readonly it: string;
          };
          readonly name: {
            readonly de: string;
            readonly en: string;
            readonly fr: string;
            readonly it: string;
          };
          readonly status: PreventionProgramEngagementStatus | null;
        };
      }> | null;
    } | null;
    readonly socialHistory: {
      readonly " $fragmentSpreads": FragmentRefs<"SocialHistoryFragment">;
    };
    readonly socialSecurityNumber: string | null;
    readonly teleGpOnboardingPerformed: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"PatientFragment" | "PatientFragmentInline" | "submitBtnAgendaTeleconsultationPatientFragment">;
  } | null;
};
export type chPatientByIdQuery = {
  response: chPatientByIdQuery$data;
  variables: chPatientByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "appointmentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "language"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "patientId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "patientId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "PatientFragment"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "country",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailAddress",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gender",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "birthDate",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "houseNumberStreet",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryLanguage",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "secondaryLanguages",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phoneNumber",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "years",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "months",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "weeks",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "days",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patientId",
  "storageKey": null
},
v25 = [
  (v8/*:: as any*/)
],
v26 = [
  (v8/*:: as any*/),
  (v24/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lockedBy",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lockedAt",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lockRequestedAt",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lockRequestedBy",
    "storageKey": null
  },
  {
    "alias": "inContextOfAppointment",
    "args": null,
    "concreteType": "Appointment",
    "kind": "LinkedField",
    "name": "appointment",
    "plural": false,
    "selections": (v25/*:: as any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "requestInContextOfAppointmentId",
    "storageKey": null
  }
],
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isEligibleForPreventionProgram",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v29 = [
  (v28/*:: as any*/)
],
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "betterDoc",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMedgateTeleGeneralPractitioner",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "referralToGeneralPractitioner",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "referralToSpecialist",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "MedgateServiceInfo",
  "kind": "LinkedField",
  "name": "medgateServiceInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ExternalAssistanceServiceInfo",
      "kind": "LinkedField",
      "name": "externalAssistanceServiceInfo",
      "plural": false,
      "selections": (v29/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "genericsObligation",
      "storageKey": null
    },
    (v30/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasBetterDocConditionPackage",
      "storageKey": null
    },
    (v31/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMedicalChatEnabled",
      "storageKey": null
    },
    (v32/*:: as any*/),
    (v33/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasInsuranceListReferralToGeneralPractitioner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasInsuranceListReferralToSpecialist",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEligibleToPartnerPortal",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "callerPhoneNumbers",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactChannel",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactChannelUpdatedAt",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "verifiedAt",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "ch_EmailVerification",
  "kind": "LinkedField",
  "name": "emailVerification",
  "plural": false,
  "selections": [
    (v39/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sentAt",
      "storageKey": null
    },
    (v38/*:: as any*/)
  ],
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "en",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "de",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fr",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "it",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "LocalizedName",
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    (v43/*:: as any*/),
    (v44/*:: as any*/),
    (v45/*:: as any*/),
    (v46/*:: as any*/)
  ],
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v50 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PreventionProgramsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      (v41/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "PatientPreventionProgramOutput",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v8/*:: as any*/),
          (v42/*:: as any*/),
          (v47/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "LocalizedInstruction",
            "kind": "LinkedField",
            "name": "localizedInstruction",
            "plural": false,
            "selections": [
              (v44/*:: as any*/),
              (v43/*:: as any*/),
              (v45/*:: as any*/),
              (v46/*:: as any*/)
            ],
            "storageKey": null
          },
          (v48/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dismissReason",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastUpdated",
            "storageKey": null
          },
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v49/*:: as any*/)
],
v51 = {
  "alias": "code",
  "args": null,
  "kind": "ScalarField",
  "name": "countryIsoCode2",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryIsoCode2",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryName",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryCode",
  "storageKey": null
},
v56 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "appointmentId"
  }
],
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "healthInformationType",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "verifiedBy",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "appointmentId",
      "variableName": "appointmentId"
    }
  ],
  "concreteType": "HealthInformationVerification",
  "kind": "LinkedField",
  "name": "healthInformationVerifications",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appointmentId",
      "storageKey": null
    },
    (v57/*:: as any*/),
    (v8/*:: as any*/),
    (v24/*:: as any*/),
    (v39/*:: as any*/),
    (v58/*:: as any*/)
  ],
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "concreteType": "HealthInformationLastVerification",
  "kind": "LinkedField",
  "name": "healthInformationLastVerification",
  "plural": true,
  "selections": [
    (v57/*:: as any*/),
    (v8/*:: as any*/),
    (v24/*:: as any*/),
    (v39/*:: as any*/),
    (v58/*:: as any*/)
  ],
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedBy",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "concreteType": "CaveEntry",
  "kind": "LinkedField",
  "name": "caveEntry",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    (v61/*:: as any*/),
    (v62/*:: as any*/)
  ],
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "businessName",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v67 = [
  {
    "kind": "Variable",
    "name": "language",
    "variableName": "language"
  }
],
v68 = {
  "alias": null,
  "args": (v67/*:: as any*/),
  "kind": "ScalarField",
  "name": "groupName",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoLanguageName",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoLanguageCode",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupType",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": (v67/*:: as any*/),
  "kind": "ScalarField",
  "name": "countryName",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "creditorCodeRegister",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMedgatePartnerNetworkMember",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isTakesNewPatients",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "website",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "globalLocationNumber",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "streetAddress",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "additionalAddress",
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationType",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationBusinessName",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationFirstName",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationLastName",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationTitle",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "concreteType": "DaySchedule",
  "kind": "LinkedField",
  "name": "detailedSchedule",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "day",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "workingType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TimePeriod",
      "kind": "LinkedField",
      "name": "periods",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "start",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "end",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "insureeNumber",
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "healthInsuranceCardNumber",
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "concreteType": "ch_Organisation",
  "kind": "LinkedField",
  "name": "organisation",
  "plural": false,
  "selections": [
    (v8/*:: as any*/),
    (v28/*:: as any*/)
  ],
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "validFrom",
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "validTo",
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrimary",
  "storageKey": null
},
v93 = {
  "alias": null,
  "args": null,
  "concreteType": "ch_Organisation",
  "kind": "LinkedField",
  "name": "organisation",
  "plural": false,
  "selections": [
    (v8/*:: as any*/),
    (v42/*:: as any*/)
  ],
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "betterDocKey",
  "storageKey": null
},
v95 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gatekeeper",
  "storageKey": null
},
v96 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shouldContainInsuranceCardNumber",
  "storageKey": null
},
v97 = [
  (v8/*:: as any*/),
  (v90/*:: as any*/),
  (v91/*:: as any*/),
  (v61/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "ch_Product",
    "kind": "LinkedField",
    "name": "product",
    "plural": false,
    "selections": [
      (v8/*:: as any*/),
      (v28/*:: as any*/),
      (v92/*:: as any*/),
      (v93/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ch_ProductConfiguration",
        "kind": "LinkedField",
        "name": "productConfiguration",
        "plural": false,
        "selections": [
          (v4/*:: as any*/),
          (v94/*:: as any*/),
          (v95/*:: as any*/),
          (v96/*:: as any*/),
          (v32/*:: as any*/),
          (v33/*:: as any*/),
          (v30/*:: as any*/),
          (v31/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v98 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "weight",
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bodyMassIndex",
  "storageKey": null
},
v102 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v103 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v104 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pharmaCode",
  "storageKey": null
},
v105 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unit",
  "storageKey": null
},
v106 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "morningDosage",
  "storageKey": null
},
v107 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "noonDosage",
  "storageKey": null
},
v108 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eveningDosage",
  "storageKey": null
},
v109 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nightDosage",
  "storageKey": null
},
v110 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "usageInstructions",
  "storageKey": null
},
v111 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "internalNotes",
  "storageKey": null
},
v112 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "templateId",
  "storageKey": null
},
v113 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "templateCategory",
  "storageKey": null
},
v114 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v115 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productUrl",
  "storageKey": null
},
v116 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "packageSize",
  "storageKey": null
},
v117 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdBy",
  "storageKey": null
},
v118 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refuseSubstitutes",
  "storageKey": null
},
v119 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfPackages",
  "storageKey": null
},
v120 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPermanentPrescription",
  "storageKey": null
},
v121 = {
  "alias": null,
  "args": null,
  "concreteType": "AccountVerification",
  "kind": "LinkedField",
  "name": "accountVerification",
  "plural": false,
  "selections": [
    (v48/*:: as any*/),
    (v11/*:: as any*/),
    (v19/*:: as any*/)
  ],
  "storageKey": null
},
v122 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ch_Patient",
    "kind": "LinkedField",
    "name": "patient",
    "plural": false,
    "selections": [
      (v8/*:: as any*/),
      (v5/*:: as any*/)
    ],
    "storageKey": null
  }
],
v123 = {
  "alias": null,
  "args": null,
  "concreteType": "ch_Patient",
  "kind": "LinkedField",
  "name": "duplicateOfPatient",
  "plural": false,
  "selections": (v25/*:: as any*/),
  "storageKey": null
},
v124 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasUpcomingPlannedAppointment",
  "storageKey": null
},
v125 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teleGpOnboardingPerformed",
  "storageKey": null
},
v126 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "socialSecurityNumber",
  "storageKey": null
},
v127 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ch_hasNonMedgateInDoctorNetwork",
  "storageKey": null
},
v128 = [
  (v14/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "CountryLookup",
    "kind": "LinkedField",
    "name": "country",
    "plural": false,
    "selections": [
      (v8/*:: as any*/),
      (v51/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "CountryLookupTranslation",
        "kind": "LinkedField",
        "name": "countryLookupTranslations",
        "plural": true,
        "selections": [
          (v52/*:: as any*/),
          (v53/*:: as any*/),
          (v54/*:: as any*/),
          (v8/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v16/*:: as any*/),
  (v15/*:: as any*/),
  (v55/*:: as any*/)
],
v129 = {
  "alias": null,
  "args": null,
  "concreteType": "Address",
  "kind": "LinkedField",
  "name": "address",
  "plural": false,
  "selections": (v128/*:: as any*/),
  "storageKey": null
},
v130 = [
  (v28/*:: as any*/),
  (v8/*:: as any*/)
],
v131 = [
  (v8/*:: as any*/),
  (v90/*:: as any*/),
  (v91/*:: as any*/),
  (v61/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "ch_Product",
    "kind": "LinkedField",
    "name": "product",
    "plural": false,
    "selections": [
      (v8/*:: as any*/),
      (v28/*:: as any*/),
      (v92/*:: as any*/),
      (v93/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ch_ProductConfiguration",
        "kind": "LinkedField",
        "name": "productConfiguration",
        "plural": false,
        "selections": [
          (v4/*:: as any*/),
          (v94/*:: as any*/),
          (v95/*:: as any*/),
          (v96/*:: as any*/),
          (v32/*:: as any*/),
          (v33/*:: as any*/),
          (v30/*:: as any*/),
          (v31/*:: as any*/),
          (v8/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v132 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "comment",
  "storageKey": null
},
v133 = {
  "alias": null,
  "args": null,
  "concreteType": "IcdDiagnosis",
  "kind": "LinkedField",
  "name": "icdDiagnosis",
  "plural": false,
  "selections": [
    (v8/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAssociation",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "diagnosisCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primaryCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "secondaryCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "associationType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v134 = {
  "alias": null,
  "args": null,
  "concreteType": "Age",
  "kind": "LinkedField",
  "name": "age",
  "plural": false,
  "selections": [
    (v20/*:: as any*/),
    (v21/*:: as any*/),
    (v22/*:: as any*/),
    (v23/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMajor",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v135 = {
  "alias": null,
  "args": null,
  "concreteType": "PatientFileLock",
  "kind": "LinkedField",
  "name": "patientFileLock",
  "plural": false,
  "selections": (v26/*:: as any*/),
  "storageKey": null
},
v136 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isContactChannelVerified",
  "storageKey": null
},
v137 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ch_Patient",
    "kind": "LinkedField",
    "name": "patient",
    "plural": false,
    "selections": [
      (v8/*:: as any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v4/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          (v24/*:: as any*/),
          (v9/*:: as any*/),
          (v10/*:: as any*/),
          (v11/*:: as any*/),
          (v12/*:: as any*/),
          (v13/*:: as any*/),
          (v129/*:: as any*/),
          (v17/*:: as any*/),
          (v18/*:: as any*/),
          (v19/*:: as any*/),
          (v134/*:: as any*/),
          (v135/*:: as any*/),
          (v27/*:: as any*/),
          (v136/*:: as any*/),
          (v36/*:: as any*/)
        ],
        "type": "Patient",
        "abstractKey": "__isPatient"
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "chPatientByIdQuery",
    "selections": [
      {
        "alias": "patientById",
        "args": (v3/*:: as any*/),
        "concreteType": "ch_Patient",
        "kind": "LinkedField",
        "name": "ch_patientById",
        "plural": false,
        "selections": [
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          {
            "kind": "InlineDataFragmentSpread",
            "name": "PatientFragmentInline",
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*:: as any*/),
                  (v6/*:: as any*/),
                  (v7/*:: as any*/),
                  (v8/*:: as any*/),
                  (v9/*:: as any*/),
                  (v10/*:: as any*/),
                  (v11/*:: as any*/),
                  (v12/*:: as any*/),
                  (v13/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "address",
                    "plural": false,
                    "selections": [
                      (v14/*:: as any*/),
                      (v15/*:: as any*/),
                      (v16/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v17/*:: as any*/),
                  (v18/*:: as any*/),
                  (v19/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Age",
                    "kind": "LinkedField",
                    "name": "age",
                    "plural": false,
                    "selections": [
                      (v20/*:: as any*/),
                      (v21/*:: as any*/),
                      (v22/*:: as any*/),
                      (v23/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PatientFileLock",
                    "kind": "LinkedField",
                    "name": "patientFileLock",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "PatientFileLockFragment"
                      },
                      {
                        "kind": "InlineDataFragmentSpread",
                        "name": "PatientFileLockFragmentInline",
                        "selections": (v26/*:: as any*/),
                        "args": null,
                        "argumentDefinitions": []
                      }
                    ],
                    "storageKey": null
                  },
                  (v27/*:: as any*/)
                ],
                "type": "Patient",
                "abstractKey": "__isPatient"
              }
            ],
            "args": null,
            "argumentDefinitions": []
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "submitBtnAgendaTeleconsultationPatientFragment"
          },
          (v8/*:: as any*/),
          (v24/*:: as any*/),
          (v34/*:: as any*/),
          (v11/*:: as any*/),
          (v19/*:: as any*/),
          (v35/*:: as any*/),
          (v36/*:: as any*/),
          (v37/*:: as any*/),
          (v38/*:: as any*/),
          (v40/*:: as any*/),
          {
            "alias": "preventionPrograms",
            "args": null,
            "concreteType": "PreventionProgramsConnection",
            "kind": "LinkedField",
            "name": "__PatientPreventionProgramsConnection_preventionPrograms_connection",
            "plural": false,
            "selections": (v50/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Address",
            "kind": "LinkedField",
            "name": "address",
            "plural": false,
            "selections": [
              (v14/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CountryLookup",
                "kind": "LinkedField",
                "name": "country",
                "plural": false,
                "selections": [
                  (v8/*:: as any*/),
                  (v51/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CountryLookupTranslation",
                    "kind": "LinkedField",
                    "name": "countryLookupTranslations",
                    "plural": true,
                    "selections": [
                      (v52/*:: as any*/),
                      (v53/*:: as any*/),
                      (v54/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v16/*:: as any*/),
              (v15/*:: as any*/),
              (v55/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "contextAppointment",
            "args": (v56/*:: as any*/),
            "concreteType": "Appointment",
            "kind": "LinkedField",
            "name": "appointment",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PatientContextAppointmentFragment"
              }
            ],
            "storageKey": null
          },
          (v59/*:: as any*/),
          (v60/*:: as any*/),
          (v63/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DoctorNetwork",
            "kind": "LinkedField",
            "name": "doctorNetworks",
            "plural": true,
            "selections": [
              (v8/*:: as any*/),
              (v64/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CareProvider",
                "kind": "LinkedField",
                "name": "careProvider",
                "plural": false,
                "selections": [
                  (v8/*:: as any*/),
                  (v65/*:: as any*/),
                  (v66/*:: as any*/),
                  (v6/*:: as any*/),
                  (v7/*:: as any*/),
                  (v68/*:: as any*/),
                  {
                    "alias": null,
                    "args": (v67/*:: as any*/),
                    "concreteType": "SpecialtyTranslation",
                    "kind": "LinkedField",
                    "name": "careProviderSpecialtyTranslations",
                    "plural": true,
                    "selections": (v29/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v67/*:: as any*/),
                    "concreteType": "OfficialLanguageLookupTranslation",
                    "kind": "LinkedField",
                    "name": "officialLanguageLookupTranslations",
                    "plural": true,
                    "selections": [
                      (v69/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OfficialLanguageLookup",
                    "kind": "LinkedField",
                    "name": "officialLanguages",
                    "plural": true,
                    "selections": [
                      (v70/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CareProviderGroup",
                    "kind": "LinkedField",
                    "name": "careProviderGroup",
                    "plural": false,
                    "selections": [
                      (v71/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CountryLookup",
                    "kind": "LinkedField",
                    "name": "country",
                    "plural": false,
                    "selections": [
                      (v72/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v73/*:: as any*/),
                  (v74/*:: as any*/),
                  (v75/*:: as any*/),
                  (v19/*:: as any*/),
                  (v76/*:: as any*/),
                  (v77/*:: as any*/),
                  (v78/*:: as any*/),
                  (v55/*:: as any*/),
                  (v14/*:: as any*/),
                  (v15/*:: as any*/),
                  (v79/*:: as any*/),
                  (v80/*:: as any*/),
                  (v81/*:: as any*/),
                  (v82/*:: as any*/),
                  (v83/*:: as any*/),
                  (v84/*:: as any*/),
                  (v85/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CareProvider",
                    "kind": "LinkedField",
                    "name": "billsVia",
                    "plural": false,
                    "selections": [
                      (v65/*:: as any*/),
                      (v6/*:: as any*/),
                      (v7/*:: as any*/),
                      (v66/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ch_Network",
                    "kind": "LinkedField",
                    "name": "network",
                    "plural": false,
                    "selections": (v29/*:: as any*/),
                    "storageKey": null
                  },
                  (v86/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_Insuree",
            "kind": "LinkedField",
            "name": "insurees",
            "plural": true,
            "selections": [
              (v8/*:: as any*/),
              (v87/*:: as any*/),
              (v88/*:: as any*/),
              (v89/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ch_Coverage",
                "kind": "LinkedField",
                "name": "activeCoverages",
                "plural": true,
                "selections": (v97/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ch_Coverage",
                "kind": "LinkedField",
                "name": "coverages",
                "plural": true,
                "selections": (v97/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PatientConditionInformationOutput",
            "kind": "LinkedField",
            "name": "conditionInformation",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PatientConditionInformationOutputFragment"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Gynaecology",
            "kind": "LinkedField",
            "name": "gynaecology",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GynaecologyFragment"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PatientAllergiesOutput",
            "kind": "LinkedField",
            "name": "allergiesInformation",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PatientAllergiesOutputFragment"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FamilyHistory",
            "kind": "LinkedField",
            "name": "familyHistory",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "FamilyHistoryFragment"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SocialHistory",
            "kind": "LinkedField",
            "name": "socialHistory",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SocialHistoryFragment"
              }
            ],
            "storageKey": null
          },
          {
            "alias": "bodyMeasurements",
            "args": null,
            "concreteType": "BodyMeasurementsConnection",
            "kind": "LinkedField",
            "name": "__PatientByIdConnection_bodyMeasurements_connection",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BodyMeasurementsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PatientBodyMeasurementsOutputFragment"
                  },
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "PatientBodyMeasurementsOutputFragmentInline",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BodyMeasurement",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*:: as any*/),
                          (v98/*:: as any*/),
                          (v99/*:: as any*/),
                          (v100/*:: as any*/),
                          (v101/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  },
                  (v41/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BodyMeasurement",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v49/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "medications",
            "args": null,
            "concreteType": "Ch_medicationsConnection",
            "kind": "LinkedField",
            "name": "__PatientByIdConnection_ch_medications_connection",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Ch_medicationsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ch_Medication",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*:: as any*/),
                      (v102/*:: as any*/),
                      (v103/*:: as any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "chMedicationFragment"
                      },
                      {
                        "kind": "InlineDataFragmentSpread",
                        "name": "chMedicationFragmentInline",
                        "selections": [
                          (v4/*:: as any*/),
                          (v8/*:: as any*/),
                          (v28/*:: as any*/),
                          (v24/*:: as any*/),
                          (v104/*:: as any*/),
                          (v102/*:: as any*/),
                          (v103/*:: as any*/),
                          (v105/*:: as any*/),
                          (v106/*:: as any*/),
                          (v107/*:: as any*/),
                          (v108/*:: as any*/),
                          (v109/*:: as any*/),
                          (v110/*:: as any*/),
                          (v111/*:: as any*/),
                          (v112/*:: as any*/),
                          (v113/*:: as any*/),
                          (v114/*:: as any*/),
                          (v115/*:: as any*/),
                          (v116/*:: as any*/),
                          (v61/*:: as any*/),
                          (v62/*:: as any*/),
                          (v38/*:: as any*/),
                          (v117/*:: as any*/),
                          (v118/*:: as any*/),
                          (v119/*:: as any*/),
                          (v120/*:: as any*/)
                        ],
                        "args": null,
                        "argumentDefinitions": []
                      },
                      (v4/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v41/*:: as any*/)
                ],
                "storageKey": null
              },
              (v49/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v121/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ch_Profile",
                "kind": "LinkedField",
                "name": "mainProfile",
                "plural": false,
                "selections": (v122/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ch_Profile",
                "kind": "LinkedField",
                "name": "childProfiles",
                "plural": true,
                "selections": (v122/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v123/*:: as any*/),
          (v124/*:: as any*/),
          (v125/*:: as any*/),
          (v126/*:: as any*/),
          (v127/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*:: as any*/),
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "chPatientByIdQuery",
    "selections": [
      {
        "alias": "patientById",
        "args": (v3/*:: as any*/),
        "concreteType": "ch_Patient",
        "kind": "LinkedField",
        "name": "ch_patientById",
        "plural": false,
        "selections": [
          (v4/*:: as any*/),
          (v8/*:: as any*/),
          (v24/*:: as any*/),
          (v34/*:: as any*/),
          (v11/*:: as any*/),
          (v19/*:: as any*/),
          (v35/*:: as any*/),
          (v36/*:: as any*/),
          (v37/*:: as any*/),
          (v38/*:: as any*/),
          (v40/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PreventionProgramsConnection",
            "kind": "LinkedField",
            "name": "preventionPrograms",
            "plural": false,
            "selections": (v50/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "connection",
            "key": "PatientPreventionProgramsConnection_preventionPrograms",
            "kind": "LinkedHandle",
            "name": "preventionPrograms"
          },
          (v129/*:: as any*/),
          {
            "alias": "contextAppointment",
            "args": (v56/*:: as any*/),
            "concreteType": "Appointment",
            "kind": "LinkedField",
            "name": "appointment",
            "plural": false,
            "selections": [
              (v8/*:: as any*/),
              (v48/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isCompleted",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "completedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "service",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appointmentType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "patientPhoneNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startingSoonNotificationSent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AppointmentChatDetails",
                "kind": "LinkedField",
                "name": "chatDetails",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "chatThreadId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "channel",
                "storageKey": null
              },
              (v54/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "medgateConnectChannel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "partnerUserEmail",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requestType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "asyncRequestStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RequestedMedication",
                "kind": "LinkedField",
                "name": "requestedMedications",
                "plural": true,
                "selections": [
                  (v28/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mainSubstance",
                    "storageKey": null
                  },
                  (v116/*:: as any*/),
                  (v104/*:: as any*/),
                  (v115/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAttribute",
                "kind": "LinkedField",
                "name": "billingAttribute",
                "plural": false,
                "selections": [
                  (v8/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isNotBillable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "notBillableReason",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "treatmentReason",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "reason",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isVisualSymptomExamination",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currentGestationWeek",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "organisationId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dateOfAccident",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accidentReference",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isEmployer",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lawType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ivgCaseReference",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mvgCaseReference",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FileUploadRequest",
                "kind": "LinkedField",
                "name": "fileUploadRequest",
                "plural": false,
                "selections": [
                  (v8/*:: as any*/),
                  (v38/*:: as any*/),
                  (v117/*:: as any*/),
                  (v114/*:: as any*/),
                  (v48/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sessionCode",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Address",
                "kind": "LinkedField",
                "name": "patientAddress",
                "plural": false,
                "selections": (v128/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "relatedPreventionPrograms",
                "plural": true,
                "selections": [
                  (v4/*:: as any*/),
                  (v42/*:: as any*/),
                  (v24/*:: as any*/),
                  (v8/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "preventionProgramId",
                    "storageKey": null
                  },
                  (v47/*:: as any*/),
                  (v10/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PreventionProgramAnalysis",
                    "kind": "LinkedField",
                    "name": "analysis",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "matchedCase",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pointOfCare",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "treatmentPlanTemplateId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v59/*:: as any*/),
          (v60/*:: as any*/),
          (v63/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DoctorNetwork",
            "kind": "LinkedField",
            "name": "doctorNetworks",
            "plural": true,
            "selections": [
              (v8/*:: as any*/),
              (v64/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CareProvider",
                "kind": "LinkedField",
                "name": "careProvider",
                "plural": false,
                "selections": [
                  (v8/*:: as any*/),
                  (v65/*:: as any*/),
                  (v66/*:: as any*/),
                  (v6/*:: as any*/),
                  (v7/*:: as any*/),
                  (v68/*:: as any*/),
                  {
                    "alias": null,
                    "args": (v67/*:: as any*/),
                    "concreteType": "SpecialtyTranslation",
                    "kind": "LinkedField",
                    "name": "careProviderSpecialtyTranslations",
                    "plural": true,
                    "selections": (v130/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v67/*:: as any*/),
                    "concreteType": "OfficialLanguageLookupTranslation",
                    "kind": "LinkedField",
                    "name": "officialLanguageLookupTranslations",
                    "plural": true,
                    "selections": [
                      (v69/*:: as any*/),
                      (v8/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OfficialLanguageLookup",
                    "kind": "LinkedField",
                    "name": "officialLanguages",
                    "plural": true,
                    "selections": [
                      (v70/*:: as any*/),
                      (v8/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CareProviderGroup",
                    "kind": "LinkedField",
                    "name": "careProviderGroup",
                    "plural": false,
                    "selections": [
                      (v71/*:: as any*/),
                      (v8/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CountryLookup",
                    "kind": "LinkedField",
                    "name": "country",
                    "plural": false,
                    "selections": [
                      (v72/*:: as any*/),
                      (v8/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v73/*:: as any*/),
                  (v74/*:: as any*/),
                  (v75/*:: as any*/),
                  (v19/*:: as any*/),
                  (v76/*:: as any*/),
                  (v77/*:: as any*/),
                  (v78/*:: as any*/),
                  (v55/*:: as any*/),
                  (v14/*:: as any*/),
                  (v15/*:: as any*/),
                  (v79/*:: as any*/),
                  (v80/*:: as any*/),
                  (v81/*:: as any*/),
                  (v82/*:: as any*/),
                  (v83/*:: as any*/),
                  (v84/*:: as any*/),
                  (v85/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CareProvider",
                    "kind": "LinkedField",
                    "name": "billsVia",
                    "plural": false,
                    "selections": [
                      (v65/*:: as any*/),
                      (v6/*:: as any*/),
                      (v7/*:: as any*/),
                      (v66/*:: as any*/),
                      (v8/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ch_Network",
                    "kind": "LinkedField",
                    "name": "network",
                    "plural": false,
                    "selections": (v130/*:: as any*/),
                    "storageKey": null
                  },
                  (v86/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_Insuree",
            "kind": "LinkedField",
            "name": "insurees",
            "plural": true,
            "selections": [
              (v8/*:: as any*/),
              (v87/*:: as any*/),
              (v88/*:: as any*/),
              (v89/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ch_Coverage",
                "kind": "LinkedField",
                "name": "activeCoverages",
                "plural": true,
                "selections": (v131/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ch_Coverage",
                "kind": "LinkedField",
                "name": "coverages",
                "plural": true,
                "selections": (v131/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PatientConditionInformationOutput",
            "kind": "LinkedField",
            "name": "conditionInformation",
            "plural": false,
            "selections": [
              (v8/*:: as any*/),
              (v48/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ConditionOutput",
                "kind": "LinkedField",
                "name": "conditions",
                "plural": true,
                "selections": [
                  (v132/*:: as any*/),
                  (v133/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Gynaecology",
            "kind": "LinkedField",
            "name": "gynaecology",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstPeriod",
                "storageKey": null
              },
              (v8/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "menopauseSince",
                "storageKey": null
              },
              (v24/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pregnancy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pregnancyHistory",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "weeksOfPregnancy",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PatientAllergiesOutput",
            "kind": "LinkedField",
            "name": "allergiesInformation",
            "plural": false,
            "selections": [
              (v8/*:: as any*/),
              (v48/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AllergyOutput",
                "kind": "LinkedField",
                "name": "allergies",
                "plural": true,
                "selections": [
                  (v8/*:: as any*/),
                  (v132/*:: as any*/),
                  (v133/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FamilyHistory",
            "kind": "LinkedField",
            "name": "familyHistory",
            "plural": false,
            "selections": [
              (v8/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "autoimmuneDisease",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cancer",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "heartDisease",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "diabetes",
                "storageKey": null
              },
              (v132/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SocialHistory",
            "kind": "LinkedField",
            "name": "socialHistory",
            "plural": false,
            "selections": [
              (v8/*:: as any*/),
              (v132/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "drinkingHabit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "smokingHabit",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BodyMeasurementsConnection",
            "kind": "LinkedField",
            "name": "bodyMeasurements",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BodyMeasurementsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BodyMeasurement",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*:: as any*/),
                      (v98/*:: as any*/),
                      (v99/*:: as any*/),
                      (v100/*:: as any*/),
                      (v101/*:: as any*/),
                      (v4/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v41/*:: as any*/)
                ],
                "storageKey": null
              },
              (v49/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "connection",
            "key": "PatientByIdConnection_bodyMeasurements",
            "kind": "LinkedHandle",
            "name": "bodyMeasurements"
          },
          {
            "alias": "medications",
            "args": null,
            "concreteType": "Ch_medicationsConnection",
            "kind": "LinkedField",
            "name": "ch_medications",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Ch_medicationsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ch_Medication",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*:: as any*/),
                      (v102/*:: as any*/),
                      (v103/*:: as any*/),
                      (v4/*:: as any*/),
                      (v28/*:: as any*/),
                      (v24/*:: as any*/),
                      (v104/*:: as any*/),
                      (v105/*:: as any*/),
                      (v106/*:: as any*/),
                      (v107/*:: as any*/),
                      (v108/*:: as any*/),
                      (v109/*:: as any*/),
                      (v110/*:: as any*/),
                      (v111/*:: as any*/),
                      (v112/*:: as any*/),
                      (v113/*:: as any*/),
                      (v114/*:: as any*/),
                      (v115/*:: as any*/),
                      (v116/*:: as any*/),
                      (v61/*:: as any*/),
                      (v62/*:: as any*/),
                      (v38/*:: as any*/),
                      (v117/*:: as any*/),
                      (v118/*:: as any*/),
                      (v119/*:: as any*/),
                      (v120/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v41/*:: as any*/)
                ],
                "storageKey": null
              },
              (v49/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "medications",
            "args": null,
            "filters": null,
            "handle": "connection",
            "key": "PatientByIdConnection_ch_medications",
            "kind": "LinkedHandle",
            "name": "ch_medications"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v121/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ch_Profile",
                "kind": "LinkedField",
                "name": "mainProfile",
                "plural": false,
                "selections": (v137/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ch_Profile",
                "kind": "LinkedField",
                "name": "childProfiles",
                "plural": true,
                "selections": (v137/*:: as any*/),
                "storageKey": null
              },
              (v8/*:: as any*/)
            ],
            "storageKey": null
          },
          (v123/*:: as any*/),
          (v124/*:: as any*/),
          (v125/*:: as any*/),
          (v126/*:: as any*/),
          (v127/*:: as any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v9/*:: as any*/),
              (v10/*:: as any*/),
              (v12/*:: as any*/),
              (v13/*:: as any*/),
              (v17/*:: as any*/),
              (v18/*:: as any*/),
              (v134/*:: as any*/),
              (v135/*:: as any*/),
              (v27/*:: as any*/),
              (v136/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "insurees",
                "plural": true,
                "selections": [
                  (v4/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "activeCoverages",
                    "plural": true,
                    "selections": [
                      (v4/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "product",
                        "plural": false,
                        "selections": [
                          (v4/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "productConfiguration",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "nursingRate",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Patient",
            "abstractKey": "__isPatient"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "af5cfa2f226e4e47c2c7e5e8515bf11e",
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "patientById",
            "preventionPrograms"
          ]
        },
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "patientById",
            "bodyMeasurements"
          ]
        },
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "patientById",
            "medications"
          ]
        }
      ]
    },
    "name": "chPatientByIdQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "bee43fc2c848adb8bcda4fb9017def37";

export default node;
